import { gql } from '@apollo/client';

/**
 * GET_PAPERS_FOR_STUDENT_CLASS
 * 
 * GraphQL query to fetch all papers/courses assigned to a student in a specific class.
 * 
 * Variables:
 * - studentClass: The class/group the student belongs to.
 * - indexNumber: The student's unique index/ID number.
 * 
 * Returns:
 * - _id: Unique identifier for the paper/course.
 * - courseName: Name of the course.
 * - courseCode: Code of the course.
 */
export const GET_PAPERS_FOR_STUDENT_CLASS = gql`
  query GetPapersForStudentClass($studentClass: String!, $indexNumber: String!) {
    getPapersForStudentClass(studentClass: $studentClass, indexNumber: $indexNumber) {
      _id
      courseName
      courseCode
    }
  }
`;

/**
 * SUBMIT_MISSING_COURSES_REPORT
 * 
 * GraphQL mutation to submit a report of missing courses for a student.
 * 
 * Variables:
 * - indexNumber: The student's unique index/ID number.
 * - missingCourseIds: Array of course IDs that the student is reporting as missing.
 * 
 * Returns:
 * - status: Boolean indicating if the submission was successful.
 * - message: Response message for user feedback.
 */
export const SUBMIT_MISSING_COURSES_REPORT = gql`
  mutation SubmitMissingCoursesReport($indexNumber: String!, $missingCourseIds: [String!]!) {
    submitMissingCoursesReport(indexNumber: $indexNumber, missingCourseIds: $missingCourseIds) {
      status
      message
    }
  }
`;
